import React from "react";
import OkendoStarRating from "components/okendo/star-rating";
import Money from "components/money";
import clsx from "clsx/lite";

const ProductDetails = ({ product, titleClass, priceClass, showFromText }) => {
	const headerProductItem = titleClass === "header-product-item";
	return (
		<div className="w-full">
			<div className="flex justify-between">
				<div className={clsx("flex flex-col items-start md:gap-2", headerProductItem && "lg:gap-0")}>
					<h5 className={clsx(titleClass || "text-sm font-semibold sm:font-bold md:text-lg")}>{product.title}</h5>
					<OkendoStarRating reviewAggregate={product?.reviewAggregate} productId={product.id} />
				</div>
				<div className={
					clsx("product-item-price flex-col justify-end items-end flex-1",
						headerProductItem && "flex items-end")}>
					{showFromText ? <span className="text-secondary text-xs md:text-sm">From</span> : null}
					<p className={clsx(priceClass || "text-xs sm:ml-2 text-end md:text-base sm:max-w-fit")}>
						<Money value={product.minVariantPrice} markets={product.variant?.markets} />
					</p>
				</div>
			</div>
		</div>
	);
};

export default ProductDetails;